<template>
  <Row v-if="getGroupByType['all'].careplans" type="flex" align="top" :gutter="15" style="padding:0px 10px 0">
    <i-col :span="24" style="margin-bottom:5px">
      <a v-if="!isLoading && ( isCurrentUser || getGroupByType['all'].careplans.length > 0)" style="margin-top: 10px; margin-left: 0px; margin-bottom: 10px;">
        <b><span v-if="isCurrentUser">MY </span>STUFF</b></a>
      <p v-if="isLoading" style="background:#ddd;height:15px;width:50%;color:red; margin-top: 10px; margin-left: 0px; margin-bottom: 10px;"></p>
    </i-col>
    <i-col :xs="8" :md="8" :lg="8" :sm="8" v-if="isLoading" v-for="i in 3" :key="i"
      class="card-container" style="position:relative">
      <!-- <Card class="card-list-item" :padding="1"> -->
        <div style="width:100%" :style="{'min-height': setAvatarHeight, 'text-align': 'center'}">
          <div class="card-content">
            <Avatar  style="border-radius:10px;font-size:3rem;line-height:5rem;background:#ddd;" :style="{'width': '70px', 'height': '70px'}"/>
          </div>
          <div style="padding:5px 3px 2px;">
            <p class="content-ellipsis" align="center" style="background:#ddd;height: 10px;"></p>
            <p class="content-ellipsis" align="center" style="width:50%;background:#ddd;height: 10px;margin-top:3px;margin:3px auto 0"></p>
          </div>
        </div>
      <!-- </Card> -->
    </i-col>

    <i-col :xs="8" :md="8" :lg="8" :sm="8" v-if="!isBroadcast && !isLoading && isCurrentUser"
      class="card-container" style="position:relative">
      <!-- <Card class="card-list-item" :padding="1"> -->
        <div class="pointer" @click="viewBookmarks('bookmarks', true)" style="width:100%" :style="{'min-height': setAvatarHeight, 'text-align': 'center'}">
          <div class="card-content" >
            <!-- <Avatar icon="ios-person" style="border-radius:10px;font-size:3rem;line-height:5rem;background:#ddd;" :style="{'width': '70px', 'height': '70px'}"/> -->
            <img style="background:#fff;border-radius:10px;display:block;margin:0 auto;width:70px;height:70px;padding:10px" src="@/assets/care-teams.jpg"/>
          </div>
          <div style="padding:0 3px;">
            <p class="content-ellipsis" style="height: 31px;">
              <small>Private Group</small></p>
          </div>
        </div>
      <!-- </Card> -->
    </i-col>
    <i-col :xs="8" :md="8" :lg="8" :sm="8" v-if="!isLoading && !isCurrentUser"
      class="card-container" style="position:relative">
      <!-- <Card class="card-list-item" :padding="1"> -->
        <div class="pointer" @click="viewTeam" style="width:100%" :style="{'min-height': setAvatarHeight, 'text-align': 'center'}">
          <div class="card-content" >
            <!-- <Avatar icon="ios-person" style="border-radius:10px;font-size:3rem;line-height:5rem;background:#ddd;" :style="{'width': '70px', 'height': '70px'}"/> -->
            <img style="background:#fff;border-radius:10px;display:block;margin:0 auto;width:70px;height:70px;" :src="getUserAvatar(journal)"/>
          </div>
          <div style="padding:0 3px;">
            <p class="content-ellipsis" style="height: 31px;">
              <small>Private Timeline</small></p>
          </div>
        </div>
      <!-- </Card> -->
    </i-col>
    <i-col :xs="8" :md="8" :lg="8" :sm="8" v-if="!isBroadcast && !isLoading"
      class="card-container" style="position:relative">
      <!-- <Card class="card-list-item" :padding="1"> -->
        <div class="pointer" @click="viewBookmarks('bookmarks', false)" style="width:100%" :style="{'min-height': setAvatarHeight, 'text-align': 'center'}">
          <div class="card-content" >
            <!-- <Avatar icon="ios-person" style="border-radius:10px;font-size:3rem;line-height:5rem;background:#ddd;" :style="{'width': '70px', 'height': '70px'}"/> -->
            <img style="background:#fff;border-radius:10px;display:block;margin:0 auto;width:70px;height:70px;padding:10px" src="@/assets/icons8-bookmark-filled-50.png"/>
          </div>
          <div style="padding:0 3px;">
            <p class="content-ellipsis" style="height: 31px;">
              <small>{{bookmarkLabel}}</small></p>
          </div>
        </div>
      <!-- </Card> -->
    </i-col>
    <i-col :xs="8" :md="8" :lg="8" :sm="8" v-if="!isLoading" v-for="i in getGroupByType['all'].careplans"
      class="card-container" style="position:relative" :key="getCareplan(i).id" v-show="isBrandGroup(getCareplan(i).id)">
      <!-- <Card class="card-list-item" :padding="1"> -->
        <div class="pointer" @click="goToGroup(getCareplan(i))" :style="{'min-height': setAvatarHeight, 'text-align': 'center'}">
          <div class="card-content">
            <img style="border-radius:10px;display:block;margin:0 auto;width:70px;height:70px" :src="getAvatar(i)"/>
          </div>
          <div style="padding:0 3px;">
            <p class="content-ellipsis" style="height: 31px;">
              <small>{{getCareplan(i).title}}</small></p>
          </div>
        </div>
      <!-- </Card> -->
    </i-col>
    <i-col :xs="8" :md="8" :lg="8" :sm="8" v-if="!isLoading & isCurrentUser"
      class="card-container" style="position:relative">
      <!-- <Card class="card-list-item" :padding="1"> -->
        <div style="width:100%" :style="{'min-height': setAvatarHeight, 'text-align': 'center'}">
          <div class="card-content pointer" style="padding-top:18px" @click="goToDiscover">
              <!-- <Avatar icon="plus" style="margin:0 auto;display:block;color:#f2f2f2" size="30" /> -->
              <Avatar icon="plus" style="margin:0 auto;display:block;color:#f2f2f2" />
          </div>
        </div>
      <!-- </Card> -->
    </i-col>
  </Row>
</template>

<script>
import Utils from '@/utils.js'
import moment from 'moment'
import { mapGetters } from 'vuex';

export default {
  data() {
    return {
      isLoading: false,
      cardSize: '100px'
    }
  },
  watch: {
    '$route': function(n,o) {
        // this.cardSize = document.querySelector('.card-list-item').clientWidth + 'px';
    }
  },
  props: {
    journal: {
      type: Object
    },
    isCurrentUser: {
      type: Boolean
    },
    hasBookmark:{
      type: Boolean
    }
  },
  computed: {
    ...mapGetters("user", ["userInfo", "brandInfo", "isBroadcast"]),
    getGroupByType: {
      get() {
          return this.$store.state.publicProfile.myGroupType
      }
    },
    setAvatarHeight: {
      get() {
        return this.cardSize
      },
      set(v) {
        console.log(v)
        this.cardSize = v;
      }
    },
    bookmarkLabel: {
      get() {
        return (this.isCurrentUser) ? "My Bookmarks" : "Bookmarks"
      }
    }
  },
  mounted() {
    this.loadGroups()
  },
  methods: {
    viewTeam() {
      this.$router.push({
        query: {
          tab: 'team'
        }
      })
    },
    getUserAvatar(user) {
      return Utils.getDisplayImage('user', user, 'medium')
    },
    getAvatar(stuff) {
      return Utils.getDisplayImage('group', stuff.careplan, 'medium')
    },
    getCareplan(v) {
      return v.careplan
    },
    goToGroup(careplan) {
      if (careplan.type == "organization")
        this.$router.push('/organization/'+careplan.id)
      else
        this.$router.push('/resources/'+careplan.id)
    },
    isBrandGroup(id) {
      if ( id === this.brandInfo.doctor_careplan_id ) return false;
      return true;
    },
    goToDiscover(id) {
      this.$router.push('/groups')
    },
    loadGroups() {
      this.isLoading = true;
      setTimeout( () => {
        this.$store.dispatch('publicProfile/getUserGroupList', {
          id: this.$store.state.publicProfile.info.data.journal_id,
          asc: 1
        }).then( res=> {
          this.isLoading = false;
          let obj = document.querySelector('.card-list-item');
          if (obj!==null) {
            this.cardSize = document.querySelector('.card-list-item').clientWidth + 'px';
          }          
        }, err=> {
          this.isLoading = false;
        })
      }, 1000)
    },
    viewBookmarks(v, isCareTeam) {
      if( isCareTeam )
        this.$router.push('/profile/' + this.$route.params.uid + '/view?careteam=1&section=' + v);
      else 
        this.$router.push('/profile/' + this.$route.params.uid + '/view?section=' + v);
    }
  }
}
</script>

<style scoped>
  .content-ellipsis {
    font-size: 12px;
    padding-top: 3px;
    display: block;
    display: -webkit-box;
    line-height: 0.9em;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
    white-space: pre-line;
    text-overflow: ellipsis;
  }
  .card-container {
    vertical-align: top;
    display: inline-block;
    margin-bottom:10px;
  }
  .card-content {
    overflow:hidden;
  }
</style>
